import BlogPostPreviewCard from 'components/blog/BlogPostPreviewCard'
import TopPoster from 'components/body/TopPoster'
import GoogleTagManagerAttributes from 'components/core/GoogleTagManagerAttributes'
import SingleTextHero from 'components/hero/SingleTextHero'
import Footer from 'components/layout/Footer'
import MainMenu from 'components/layout/MainMenu'
import TopMenuBar from 'components/layout/TopMenuBar'
import Env from 'Env'
import { TopPosterModel } from 'models/body/TopPosterModel'
import { BlogCategoryModel } from 'models/core/BlogCategoryModel'
import { BlogPostModel } from 'models/core/BlogPostModel'
import { MenuModel } from 'models/menu/MenuModel'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { ApiPromise } from 'services/ApiPromise'
import { Converters } from 'services/Converters'

type Props = {
  menu: MenuModel
  footer: MenuModel
  blogPosts: BlogPostModel['data'][]
  isPreview: boolean
  metaName: string
  posters: {
    data: TopPosterModel[]
  }
}

const BlogCategoryPage: NextPage<Props> = (props) => {
  const blogPageTitle = 'SecureMyEmail Blog'
  return (
    <Fragment>
      <Head>
        <title>{`Blog Category - ${props.metaName}`}</title>
      </Head>
      <GoogleTagManagerAttributes />
      {props.posters.data.map((poster, index) => (
        <TopPoster key={index} data={poster} />
      ))}
      <TopMenuBar />
      <MainMenu menu={props.menu} />
      <div className="lg:pt-10">
        <SingleTextHero data={{ title: blogPageTitle }} />
      </div>
      <div className="container">
        <div className="blog-list md:px-7 px-4 py-12 shadow-[0_1px_18px_rgba(239,239,239,1)]">
          {props.blogPosts.map((post, index) => {
            return <BlogPostPreviewCard key={index} post={post} />
          })}
        </div>
      </div>
      <Footer data={props.footer} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const isPreview = context.preview
  const convert = (input: any) => Converters.KeysConvert.ToLowerCase(input)
  const menuAndFooter = ApiPromise.Layout.GetMainAndFooterMenu()
  const [menuPromise, footerPromise, postersPromise] = await Promise.all(menuAndFooter)
  const [menu, footer, posters] = Converters.KeysConvert.ConvertAllToLower([menuPromise.data, footerPromise.data, postersPromise.data])
  const posts = await ApiPromise.Blog.PostsByCategory(context.params?.slug as string).then((resp) => convert(resp.data))
  const blogPosts = posts['data']
  const categories = await ApiPromise.Blog.BlogPostCategories().then((resp) => resp.data['data'])
  const getCategoryName = () => {
    for (const cat of categories) {
      if (cat.attributes.Slug === context.params?.slug) {
        return cat.attributes.Title
      }
    }

    return ''
  }

  return { props: { menu, footer, blogPosts, posters, metaName: getCategoryName(), isPreview: isPreview ? true : false }, revalidate: Env.PropsRevalidateTime }
}

export const getStaticPaths: GetStaticPaths = async (context) => {
  const convert = (input: any) => Converters.KeysConvert.ToLowerCase(input)
  const categories = await ApiPromise.Blog.BlogPostCategories().then((resp) => resp.data['data'])
  const paths: { params: { slug: string } }[] = []
  categories.forEach((category: any) => {
    paths.push({ params: { slug: category.attributes.Slug } })
  })
  return {
    paths,
    fallback: 'blocking',
  }
}

export default BlogCategoryPage
